
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcFormGroup as ObcFormGroupElement} from '@oicl/openbridge-webcomponents/dist/components/form-group/form-group.js';
 import {ObcFormItemActionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/form-item/form-item.js';
 export type {ObcFormItemActionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/form-item/form-item.js';
 

 
 export const ObcFormGroup = createComponent({
   react: React,
   tagName: 'obc-form-group',
   elementClass: ObcFormGroupElement,
   events: {
     
     onActionChange: 'action-change' as EventName<ObcFormItemActionChangeEvent>,
   }
  });
 
 